module.exports = __webpack_public_path__ + "img/icon-live-your-life.ec12519f.svg";